import { Component, Input } from '@angular/core';
import { IconName, IconNamesEnum } from 'ngx-bootstrap-icons';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-attachment-button',
  templateUrl: './attachment-button.component.html',
  styleUrls: ['./attachment-button.component.scss'],
})
export class AttachmentButtonComponent {
  @Input() icon: IconNamesEnum | IconName;
  @Input() text?: string;
}
